import { SharedText } from '../@types/Acertei';
import { Questao } from '../@types/Questao';
import Service from './Service';

export type SharedTextPayload = {
  title: string;
  body: string;
  source?: string;
};

class SharedTextService extends Service {
  static list() {
    return this.Http.get<SharedText[]>('/shared-texts').then(this.getData);
  }

  static get(id: string) {
    return this.Http.get<SharedText>(`/shared-texts/${id}`).then(this.getData);
  }

  static create(payload: SharedTextPayload) {
    return this.Http.post<SharedText>('/shared-texts', payload).then(this.getData);
  }

  static update(id: string, payload: SharedTextPayload) {
    return this.Http.put<SharedText>(`/shared-texts/${id}`, payload).then(this.getData);
  }

  /**
   * Sem `force`, a API responde 409 com `question_count` quando ainda há
   * questões vinculadas — a view usa isso para oferecer o desvínculo.
   */
  static remove(id: string, force = false) {
    return this.Http.delete<{ deleted: boolean; unbound: number }>(
      `/shared-texts/${id}${force ? '?force=true' : ''}`
    ).then(this.getData);
  }

  static listQuestions(id: string) {
    return this.Http.get<Questao.Questao[]>(`/shared-texts/${id}/questions`).then(this.getData);
  }
}

export default SharedTextService;
